$(".star-rating-radio").addClass("star-rating-radio-js");

$(".star-rating-radio label").click(function () {
	$(this).addClass("star-rating-radio-hl");
	$(this).parent().prevAll(".form-check").children("label").addClass("star-rating-radio-hl");
	$(this).parent().nextAll(".form-check").children("label").removeClass("star-rating-radio-hl");
});
